import React from "react";
import { Col } from "react-bootstrap";

function AnimatedCol(props) {
  const { expand = true } = props;

  const hide = `${expand ? "box" : "d-sm-none"} `;

  return (
    <Col md={12} className={hide}>
      {props.children}
    </Col>
  );
}

export default AnimatedCol;
